import { render, staticRenderFns } from "./GatewayBulkUploadScreen.vue?vue&type=template&id=632b0766&scoped=true&lang=pug"
import script from "./GatewayBulkUploadScreen.vue?vue&type=script&lang=ts"
export * from "./GatewayBulkUploadScreen.vue?vue&type=script&lang=ts"
import style0 from "./GatewayBulkUploadScreen.vue?vue&type=style&index=0&id=632b0766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b0766",
  null
  
)

export default component.exports